module.exports = __webpack_public_path__ + "static/media/Exchange rate information Assistance.9aab5d5d.png";